import type { GridValueFormatter } from '@mui/x-data-grid-pro';
import { isEmpty } from 'lodash';

export const formatUnassigned: GridValueFormatter = (value: string) => {
  if (isEmpty(value)) return 'unassigned';
  return value;
};
